import { create } from "zustand";
import { getOptionMonthSubmit, submitReportVoc, updateApproveStep } from "src/services/waste-water.service";
import { SubmitReportVocBody } from "src/entity/common/global.entity";
import { ApproveBody } from "src/entity/voc-approve/voc-approve.entity";
import { WasteWaterApproveStoreProps } from "./interface/waste-water-approve-store.interface";
import { getInfoStepApproval, getOptionVocApproval } from "src/services/voc-approval";

export const wasteWaterApproveStore = create<WasteWaterApproveStoreProps>((set) => ({
  loading: false,
  loadingSubmitVocReport: false,
  loadingGetApprove: false,
  approveData: null,
  selectedApprove: null,
  optionMonth: [],
  optionApprove: { year: [], month: [], approveNo: [] },
  error: null,
  getMonthCanApprove: async (year: string) => {
    set(() => ({ loading: true }));
    try {
      const res = await getOptionMonthSubmit(year);
      // console.log("[Response Option MOnth] RESPONSE : ", res.data);
      set(() => ({ loading: false, optionMonth: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, optionMonth: [] }));
    }
  },
  createSubmitReportVoc: async (payload: SubmitReportVocBody) => {
    set(() => ({ loadingSubmitVocReport: true }));
    try {
      await submitReportVoc(payload);

      set(() => ({ loadingSubmitVocReport: false }));
    } catch (err: any) {
      set(() => ({ loadingSubmitVocReport: false, error: err?.message }));
      throw err;
    }
  },
  getInfoStepApprove: async (query: string) => {
    set(() => ({ loadingGetApprove: true }));
    try {
      const res = await getInfoStepApproval(query);
      set(() => ({ loadingGetApprove: false, approveData: res.data?.data || null, selectedApprove: res.data?.data?._id || null }));
    } catch (err: any) {
      set(() => ({ loadingGetApprove: false, error: err?.message, approveData: null, selectedApprove: null }));
    }
  },
  getOptionApprove: async (query: string) => {
    set(() => ({ loading: true }));
    try {
      const res = await getOptionVocApproval(query);

      set(() => ({ loading: false, optionApprove: res.data?.data || {} }));
      return res.data?.data || [];
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, optionApprove: { year: [], month: [], approveNo: [] } }));
    }
  },
  updateApproveStep: async (data: ApproveBody) => {
    set(() => ({ loading: true }));
    try {
      const res = await updateApproveStep(data);

      set(() => ({ loading: false }));
      return res.data?.data || [];
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message }));
      throw err;
    }
  },
}));
